import React, { useState, useEffect, useRef } from 'react'

const componentStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
    }
}

export default function VStack(props) {
    const {
        grow = 0,
        styles = {},
        stackRef,
        children,
    } = props

    const rootStyle = {
        ...componentStyles.root, 
        flexGrow: grow,
        ...styles.root,
    }

    return (
        <div ref={stackRef} style={rootStyle}>
            {children}
        </div>
    )
}